<template>
  <div class="crud_module--cp_by_charging_rate">
    <br>
    <div class="row">
      <div class="item">
        <div class="cps">
          <div class="cp_title"><input v-if="false" :disabled="isView()" type="checkbox" v-model="select_all" @change="selectAll()">{{$t('menu.item.cp')}}</div>
          <div class="cp_content">
            
            <div class="el-row cp_loc" v-for="i in Object.keys(cp_loc)" :key="i">
              <div class="cp_loc_title">{{cp_loc[i].address}}</div>
              <div class="cp el-col " v-for="row in cp_loc[i].cps" :key="row.cp_id">
                <input :disabled="isView() || disabled_cp.includes(row.cp_id)" type="checkbox" :id="'cps-'+row.cp_id" :value="row.cp_id" @change="selectOne()" v-model="select_cp">
                <label :for="'cps-'+row.cp_id" class="label">{{row.cp_no}}</label>
              </div>
            </div>
            <!-- <div class="el-row" >
              <div class="cp el-col " v-for="row in cps" :key="row.cp_id">
                <input :disabled="isView() || disabled_cp.includes(row.cp_id)" type="checkbox" :id="'cps-'+row.cp_id" :value="row.cp_id" @change="selectOne()" v-model="select_cp">
                <label :for="'cps-'+row.cp_id" class="label">{{row.cp_no}}</label>
              </div>
            </div> -->
            <div class="action" v-if="action!='View'">
              <el-button size="small" type="primary" @click="confirm">{{ $t("button.confirm") }}</el-button>
              <!-- <el-button size="small" type="primary" @click="test">test</el-button> -->
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["data","col","k","action"],
  async created() {
    
  },
  async beforeMount() {
    this.id = this.$route.params.id;
    await this.init();
  },
  methods: {
    isView(){
      if(this.action=='View'){
        return true;
      }
      return false;
    },
    async init() {
      var _this = this;
      console.log("_this.data",_this.data);
      await this.$axios.get(`/cps`, {
        params: {
          size: 99999,
          page: 0,
          trash: 0,
          locId:(_this.data.loc_id==undefined?-1:_this.data.loc_id)
        }
      }).then(res=>{
        let data = res.data.response.dataset;
        _this.cps = data.content;
        // console.log(data.content);
        for(var i in data.content){
          var cp = {
            cp_id:data.content[i].cp_id,
            cp_no:data.content[i].cp_no
          };
          var cpLocId = data.content[i].loc_id.loc_id;
          
          if(_this.cp_loc[cpLocId] == undefined){
            _this.cp_loc[cpLocId] = {};
            _this.cp_loc[cpLocId].loc_id = cpLocId;
            _this.cp_loc[cpLocId].address = data.content[i].loc_id.address;
            _this.cp_loc[cpLocId].cps = [];
          }
          _this.cp_loc[cpLocId].cps.push(cp);
          this.$forceUpdate();
        }
        console.log("_this.cp_loc",_this.cp_loc);
        return true;
      }).catch(err=>{ return false; });

      await this.$axios.get(`/charging_rate_detail_cp_group`, {}).then(res=>{

        _this.select_cp = [];
        console.log(res);
        for(var i in res.data){
          if(i == _this.id){
            for(var j in _this.cp_loc){
              for(var k in _this.cp_loc[j].cps){
                var data = _this.cp_loc[j].cps[k];
                if(res.data[i].includes(data.cp_id)){
                  console.log(data.cp_id);
                  _this.select_cp.push(data.cp_id);
                }
              }
            }
          }
          else {
            _this.disabled_cp.push(...res.data[i]);
          }
        }
        for(var i in res.data.cpIds){
          var d = res.data.cpIds[i];
          _this.select_cp.push(d);
        }
        _this.selectOne();
        // console.log(res.data);
        return true;
      }).catch(err=>{ return false; });
    },
    async confirm(){
      await this.$axios.post(`/charging_rate_detail_cp_group`, {
        chargingRateId:this.id,
        cpIds:this.select_cp
      }).then(res=>{
        if(res.data == "Success"){
          this.$message({
            message: this.$t("message.save_successfully"),
            type: 'success'
          });
        }
        else {
          this.$message({
            message: this.$t("error.generic"),
            type: 'error'
          });
        }
      }).catch(err=>err);
    },
    selectAll(){
      var list = this.cps;
      var arr = [];
      if(this.select_all){
        for(var i in list){
          var cp = list[i];
          arr.push(cp.cp_id);
        }
      }
      this.select_cp = arr;
    },
    selectOne(){
      var length = this.cps.length;
      var tlength = this.select_cp.length;
      if(length == tlength){
        this.select_all = true;
      }
      else {
        this.select_all = false;
      }
    }
  },
  computed:{
  },
  data() {
    return {
      disabled_cp:[],
      cp_loc:{},
      cps:[],
      select_cp:[],
      id:0,
      select_all:false,
      value:undefined
    }
  }
}
</script>

<style lang="scss">
.crud_module--cp_by_charging_rate{
  .row{
    display: flex;
    margin-bottom: 20px;
    width: 100%;
    max-width: 100%;
    .item{
      flex-grow: 1;
      display: flex;
      width: 100%;
      font-size: x-small;
      // margin-right: 20px;
      .item__type--tab{
        flex-grow: 1;
        overflow-x: auto;
      }
      .data{
        width: 100%;
        display: flex;
      }
      .label{
        width: 130px;
        min-width: 130px;
        display: flex;
        align-items: center;
      }
      .value{
        min-width: 200px;
        width: 100%;
        > input{
          width: calc(100% - 10px);
          height: 25px;
          padding: 5px;
        }
        > select{
          width: 100%;
          height: 35px;
          padding: 5px;
        }
      }
      .cp_loc{
        border: #ddd 1px solid;
        margin: 0 5px 5px ;
      }
      .cp_loc_title{
        // margin-bottom: 10px;
        font-size: larger;
        background: rgb(232,234,236);
        color: #000;
        padding: 5px 10px;
        font-weight: bolder;
      }
      .cp_title{
        margin-bottom: 10px;
        font-size: small;
        background: #414e75;
        color: white;
        padding: 5px 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        font-weight: bolder;
      }
      .cp{
        display: flex;
        padding-left: 5px; 
        padding-right: 5px;
        font-size: larger;
        float: left;
        width: 10%;
        margin: 2px 0;
      }
      .cps{
        border: 1px solid #e3e3e3;
        border-radius: 5px;
        box-shadow: 0px 1px 5px #ddd;
        display: flex;
        flex-direction: column;
        background: white;
        width: 100%;
      }
      .action{
        margin: 5px;
      }
    }
  }
}
</style>